import axios from 'axios';

import dokey from '../utils/dokey.js'


// 创建axios实例
const service = axios.create({
  baseURL: "https://server.kaoshla.com/", // api的base_url
  timeout: 5000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 例如设置请求头
    // if (store.getters.token) {
    //   config.headers['X-Token'] = getToken();
    // }
    config.headers = {
      ...config.headers,
      'E-MHM-ID': 1,
      'E-DEVICE-TYPE': "h5",
      'E-APP-ID': "nq26V5EqmNtA9TetP",
      ...dokey.secretdate({}),
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    console.error('请求出错：', error); // for debug
    Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可通过配置白名单 字典来对接接口状态码
     * 附带错误信息
     * 以下为简单处理，根据业务需求，可以调整
     */
    const res = response.data;
    if (res.code !== 1) {
      console.error('错误码：', res.code); // for debug
      // 可以在这里处理错误，比如使用Message.error等
      return Promise.reject(new Error(res.message || 'Error'));
    } else {
      return res;
    }
  },
  error => {
    console.error('响应出错：', error); // for debug
    return Promise.reject(error);
  }
);

/**
 * 获取最新的下载地址
 * @param url
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function getAppDownloadUrl(url) {
  return service.get(url);
}

export function postData(url, data) {
  return service.post(url, data);
}

// 导出service，可能其他页面也需要使用
export default service;



// WEBPACK FOOTER //
// ./src/api/index.js